<template>
  <!-- menu add -->
  <div>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      :footer="null"
      @ok="closeFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
    >
      <x-addEdit
        ref="addEdit"
        :itemLayout="$store.state.modal_ItemLayout"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
        :initReqHandle = 'initReqHandle'
      >
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { findListItem, handleHttpMethod } from '@/utils/common';
import { fetchSelect } from '@/utils/mixins';
export default {
  name: 'peopleControlKeyPersonnelAdd',
  mixins: [fetchSelect],
  components: { },
  data () {
    return {
      initReqHandle: false,
      modalTitle: '新增',
      visible: false,
      lngLat: [],
      position: '',
      inputKey: {
        lng: 'mapLng',
        lat: 'mapLat',
        address: 'address'
      },
      formList: [
        {
          label: '菜单图标',
          inputType: 'upload',
          options: [],
          handle: '',
          fileList: [],
          placeholder: '',
          tip: 'tip',
          beforeHandle: this.beforeUpload,
          limit: 1,
          uploadParam: {
            url: '/local/upload',
            iconUrl: 'iconUrl',
            iconName: 'fileName',
            action: this.$store.state.uploadUrlJava,
            accept: this.$store.state.imgAccept,
            listType: 'picture',
            accept: '.jpg,.jpeg,.png,.gif',
            limit: 1,
            uploadType: 4 // // 上传的文件类型
          },
          props: ['icon', {
            rules: [{ required: true, message: '请上传菜单图标' }]
          }]
        }, {
          label: '菜单名称',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入名称',
          props: ['title', {
            rules: [{ required: true, message: '请输入名称' }]
          }]
        }, {
          label: '排序',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入',
          props: ['sort', {
            rules: [{ required: true, message: '请输入排序序号' }, { pattern: this.REG.nonnegativeInteger, message: this.MESSAGE.nonnegativeInteger }]
          }]
        },
        {
          disabled: false,
          label: '绑定类目',
          inputType: 'treeSearch',
          options: [],
          handle: '',
          isSearch: false,
          placeholder: '请选择',
          props: ['categoryIds', {
            rules: [
              { required: true, message: '请绑定类目' }
            ]
          }]
        },
        {
          label: '二级菜单类型',
          inputType: 'select',
          options: [
          ],
          handle: '',
          placeholder: '请选择',
          props: ['childType', {
            rules: [{ required: true, message: '请选择二级菜单类型' }]
          }]
        },
        {
          label: '列表筛选类型',
          inputType: 'select',
          options: [],
          handle: '',
          placeholder: '请选择',
          props: ['searchType', {
            rules: [{ required: true, message: '请选择列表筛选类型' }]
          }]
        }
      ],
      formKey: {
        icon: undefined,
        title: undefined,
        sort: undefined,
        searchType: undefined,
        childType: undefined,
        categoryIds: undefined
      },
      addParam: {
        url: '/local/menu',
        reqHandle: this.addreqHandle, // addParam、editParaM都会执行 reqHandle方法
        resHandle: this.ResHandle
      },
      editParam: {
        url: '/local/menu/',
        pathParam: true,
        resHandle: this.ResHandle
      },
      detailParam: {
        url: '/local/menu/',
        resHandle: this.detailResHandle // this.detailResHandle
      }
    };
  },
  created () {
    this.getSelection();
  },
  methods: {
    beforeUpload (file, fileList, item) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif';
      if (!isJpgOrPng) {
        this.$message.error('请选择jpg、jpeg、png或者gif格式的图片!');
      }
      // const isLt50k = file.size / 1024 < 50;
      // if (!isLt50k) {
      //   this.$message.error('图片最大为50k!');
      // }
      // isLt50k &&
      return isJpgOrPng;
    },
    getSelection () {
      this.$get({
        url: '/local/menu/categoryTreeselect'
      }).then(res => {
        this.recursionList(res.data.menus);
        this.formList[3].options = res.data.menus;
      });
      this.dictionarySelect([{index: 4, scope: 'formList', query: 'comu_local_child_type'}]);
      this.dictionarySelect([{index: 5, scope: 'formList', query: 'comu_local_search_type'}]);
    },
    recursionList (list) {
      list.forEach(item => {
        item.title = item.label;
        item.key = item.value;
        if (item.children && item.children.length) {
          this.recursionList(item.children);
        }
      });
    },
    closeFun () {
      this.visible = false;
      this.formList[0].fileList = [];
    },
    show (id) {
      this.formList[3].options = [];
      this.visible = true;
      let arr = this.formList.filter(
        item => item.props && item.props[0] == 'childType'
      );
      if (this.$route.query.menuId) {
        this.formList.splice(4, 2);
      }
      if (id) {
        this.modalTitle = '编辑';
        let url = `${this.editParam.url}${id}`;
        this.$nextTick(() => {
          this.$refs.addEdit.routeQuery = id;
          this.$refs.addEdit.getDetail(url);
        });
        // arr.forEach((el) => { el.disabled = true; });

        this.$get({
          url: '/local/menu/categoryTreeselect',
          params: {menuId: id}
        }).then(res => {
          this.recursionList(res.data.menus);
          this.formList[3].options = res.data.menus;
          this.$refs.addEdit.defaultTree = res.data.checkedKeys;
          this.$refs.addEdit.treeCheck(res.data.checkedKeys, 'categoryIds');
        });
      } else {
        let id = this.$route.query.menuId;
        this.modalTitle = '添加';
        this.$get({
          url: '/local/menu/treeselect',
          params: {menuId: id}
        }).then(res => {
          this.recursionList(res.data);
          this.formList[3].options = res.data;
        });
      }
    },
    ResHandle (res) {
      this.closeFun();
      this.$emit('updateTable', res);
      return res;
    },
    detailResHandle (res) {
      return res;
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    },
    addreqHandle (req) {
      let choseList = req.categoryIds;
      let arr = this.findFatherNode(choseList);
      req.categoryIds = arr;
      if (this.$route.query.menuId) {
        req.parentId = this.$route.query.menuId;
      }
      return req;
    },
    findFatherNode (list) {
      let arr = [];
      this.formList[3].options.forEach(item1 => {
        if (list.includes(item1.value)) {
          arr.push(item1.value);
        }
        if (item1.children && item1.children.length) {
          item1.children.forEach(item2 => {
            if (list.includes(item2.value)) {
              arr.push(item2.value);
              arr.push(item1.value);
            }
            if (item2.children && item2.children.length) {
              item2.children.forEach(item3 => {
                if (list.includes(item3.value)) {
                  arr.push(item3.value);
                  arr.push(item2.value);
                  arr.push(item1.value);
                }
                if (item3.children && item3.children.length) {
                  item3.children.forEach(item4 => {
                    if (list.includes(item4.value)) {
                      arr.push(item4.value);
                      arr.push(item3.value);
                      arr.push(item2.value);
                      arr.push(item1.value);
                    }
                  });
                }
              });
            }
          });
        }
      });
      arr = [...new Set(arr)];
      return arr;
    }
  }
};
</script>
<style lang="less" scoped>
</style>
